/** Map a book picture onto its Firebase Storage object. Pure: no network. */

function stripQuery(url) {
  return String(url || '').split('?')[0];
}

/** `/content/projects/...` or a full host URL with that path. */
export function storagePathFromContentUrl(url) {
  const match = stripQuery(url).match(/\/content\/(projects\/.+)$/);
  return match ? match[1] : '';
}

export function storagePathForGeneration(projectId, generation) {
  if (!generation) return '';
  if (generation.storagePath) return String(generation.storagePath);
  const fromUrl = storagePathFromContentUrl(generation.output?.contentUrl);
  if (fromUrl) return fromUrl;
  const relative = generation.output?.path;
  if (projectId && relative) {
    return `projects/${projectId}/${String(relative).replace(/^\/+/, '')}`;
  }
  if (projectId && generation.id) {
    return `projects/${projectId}/generations/${generation.id}.png`;
  }
  return '';
}

export function storagePathForExport(projectId, export300) {
  if (!export300) return '';
  if (export300.storagePath) return String(export300.storagePath);
  const fromUrl = storagePathFromContentUrl(export300.contentUrl);
  if (fromUrl) return fromUrl;
  if (projectId && export300.path) {
    return `projects/${projectId}/${String(export300.path).replace(/^\/+/, '')}`;
  }
  return '';
}
